import Immutable from "immutable";

import { Features } from "resourceModels/Client";
import { getResource } from "selectors/resources";
import BaseMessageRecord, {
  BaseMessageRecordAttributes,
  BlockConfigGetter
} from "../BaseMessageRecord";

interface CsatMessageRecordAttributes extends BaseMessageRecordAttributes {
  type: "csat_survey"
}

export default class CsatMessageRecord extends BaseMessageRecord<CsatMessageRecordAttributes>({
  type: "csat_survey"
}) {
  static blockConfig: BlockConfigGetter = state => ({
    isVisible: getResource(state, "client").hasFeature(Features.CSAT_PRO_BLOCK),
    blockName: "Satisfaction",
    blockType: "action",
    shortTitle: "Satisfaction",
    blockTitle: "Satisfaction Survey",
    icon: "Heart"
  })

  static getInvalidFields = (): Immutable.List<string> => Immutable.List();
}
